/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Сторінку не знайдено",
  "ComingSoon": "Скоро буде",
  "YesanPersonalFinance": "Yesan, Особисті фінанси",
  "Yesan": "Yesan",
  "PersonalFinance": "Особисті фінанси",
  "YesanDownload": "Yesan Завантажити",
  "ThisWebsiteUsesCookies": "Ми використовуємо файли cookie для збору та аналізу інформації про роботу та використання нашого сайту, а також для надання функцій соціальних мереж. Продовжуючи, ви погоджуєтеся з нашою",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Станьте фінансово вільними",
  "inStepsAndActions": "за 8 кроків та 3 дії.",
  "TrackPlanAnalyze": "Відстежуйте. Плануйте. Аналізуйте.",
  "FTrack": "1. Відстежувати",
  "FPlan": "2. Плануйте",
  "FAnalyze": "3. Аналізуйте",
  "Features": "Можливості",
  "FeaturesSubHeading": "Чистий новачок, вже фінансово грамотний, це додаток, який вам потрібен, щоб стати фінансово вільним.",
  "ManageAccounts": "Керуйте рахунками",
  "CashLiquidFixedAssetsLiabilities": "Готівка, ліквідність, основні засоби та зобов'язання.",
  "TrackTransactions": "Відстежуйте транзакції",
  "IncomesExpensesTransferInvestments": "Доходи, витрати, перекази, інвестиції.",
  "ImportExport": "Імпорт/експорт",
  "YourDataAlwaysAccessible": "Ваші дані завжди доступні.",
  "PlanYourFreedom": "Плануйте свою свободу",
  "StepsAwayFromFI": "8 кроків до фінансової незалежності.",
  "BudgetsAndGoals": "Бюджети та цілі",
  "CheckYourProgressAndAchieve": "Відстежуйте свій прогрес та досягайте фінансових цілей.",
  "DashboardAndAnalytics": "Інформаційна панель та аналітика",
  "ReviewLearnOptimizeWith": "Переглядайте, вивчайте, оптимізуйте за допомогою графіків, аналітики та інструментів.",
  "Security": "Безпека",
  "MilitaryGradeEncryption": "Шифрування військового рівня, підтримка біометрії, дані зберігаються на ваших пристроях.",
  "OfflineMode": "Автономний режим",
  "YourDataAlwaysAccessibleAndModif": "Ваші дані завжди доступні та можуть бути змінені.",
  "Track": "Відстежувати",
  "Income": "Доходи",
  "Expense": "Витрати",
  "Transfer": "Перекази",
  "transactionsAndManageAccounts": "транзакції та керуйте різноманітними рахунками:",
  "checkings": "Чековий",
  "savings": "Ощадні",
  "realEstate": "Нерухомість",
  "stocks": "Фондові ринки",
  "bonds": "Облігації",
  "crypto": "Криптовалюта",
  "notes": "Банкноти, Гаманець",
  "envelopes": "Конверти",
  "privateEquity": "Прямі інвестиції",
  "metal": "Дорогоцінні метали",
  "retirement": "Пенсійне страхування",
  "lifeInsurance": "Страхування життя",
  "intellectualProperty": "Інтелектуальна власність",
  "otherLiquidAsset": "Інші ліквідні активи",
  "otherFixedAsset": "Інші основні засоби",
  "mortgage": "Іпотека",
  "loan": "Споживчий кредит",
  "creditCard": "Кредитна картка",
  "otherLiability": "Інші зобов'язання",
  "AccountsManagement": "Управління рахунками",
  "MultipleAccountsTypesAndGrouping": "Різноманітні типи та групування рахунків",
  "LinkAccounts": "Прив'язуйте рахунки ваших установ (доступно лише в деяких країнах)",
  "SmartAccounts": "Розумні рахунки",
  "AddEditDeleteTransactions": "Додавання/редагування/видалення транзакцій",
  "TickVerifiedTransactions": "Відмічайте перевірені транзакції",
  "CategorizeTransactions": "Класифікувати транзакції за категоріями",
  "TagTransactions": "Позначати транзакції тегами",
  "TrackKakeiboType": "Відстежувати тип Kakeibo",
  "TrackInvestments": "Відстежувати інвестиції (доступно лише в деяких країнах)",
  "ImportFromCSVFile": "Імпортувати повністю або поетапно транзакції з CSV-файлу",
  "ExportToCSVFile": "Експортувати транзакції в CSV файл",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 кроків до фінансової незалежності план, детальне бюджетування, швидше досягайте своїх фінансових цілей.",
  "levelsTowardsFI": "8 рівнів на шляху до фінансової незалежності",
  "EstablishBudgetsPer": "Створюйте бюджети для кожного",
  "account": "рахунок",
  "accountType": "тип рахунку",
  "KakeiboType": "Тип Kakeibo",
  "category": "категорія",
  "tag": "тег",
  "label": "етикетка",
  "TrackBudgetsPerFrequency": "Відстежуйте бюджети за частотою",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Створюйте цілі за витратами, балансом, грошовими потоками, діями",
  "TrackGoalsProgress": "Відстежуйте прогрес цілей",
  "ReviewLearnOptimizeWithReportsCharts": "Переглядайте, вивчайте, оптимізуйте за допомогою звітів, діаграм, трендів, інсайтів, інструментів.",
  "Dashboard": "Інформаційна панель",
  "FSNetWorth": "Фінансова звітність: Чистий капітал",
  "FSPnL": "Фінансова звітність: Звіт про фінансові результати / Звіт про прибутки та збитки",
  "FSBalanceSheetAssetsLiabilities": "Фінансова звітність: Баланс, Активи, Зобов'язання",
  "FSCashFlow": "Фінансова звітність: Звіт про рух грошових коштів, дебет-кредит, потоки",
  "FSFlows": "Фінансова звітність: Рух коштів",
  "FSRatios": "Фінансова звітність: Коефіцієнти",
  "TrendsMonthEnd": "Тенденції на кінець місяця: Доходи та витрати, Грошовий потік",
  "TrendsPerformance": "Динаміка результатів діяльності: Рік до року, місяць до місяця, тиждень до тижня",
  "IncomeTrendsPer": "Динаміка доходу на одну особу",
  "SpendingTrendsPer": "Динаміка витрат на",
  "RecurringItemsIE": "Періодичні статті: Доходи та витрати",
  "DebtProgressTrends": "Динаміка боргового прогресу",
  "KakeiboMTDReviewTrends": "Kakeibo: Огляд MTD, останній місяць, тенденції",
  "FIWCLE": "Фінансова незалежність: Настінна діаграма, витрати за життєвою енергією",
  "DebtPaydownSnowballAvalanche": "Виплата боргу: Снігова куля, лавина",
  "FullyCustomizableAnalyticsRange": "Повністю настроюється часовий діапазон аналітики",
  "ContactUs": "Зв'яжіться з нами",
  "Privacy": "Конфіденційність",
  "Terms": "Умови",
  "About": "Про нас",
  "IAgreeToThe": "Я погоджуюся з",
  "AndThe": "та",
  "PrivacyPolicy": "Політикою конфіденційності",
  "TermsOfUse": "Умови використання",

  "DigitalSoftwareExperienceTagline": "Досвід роботи з цифровим програмним забезпеченням для сучасного світу",
  "DigitalExperience": "Цифровий досвід",
  "SoftwareForTheModernWorld": "Програмне забезпечення для сучасного світу",
  "MobileApplications": "Мобільні додатки",
  "forConnectedAndOfflineHumans": "для людей, що підключені та не підключені до мережі",
  "CloudSaaS": "Хмарні SaaS",
  "ResponsiveAndWebServices": "Адаптивні та веб-сервіси",
  "PersonalFinanceServices": "Персональні фінансові сервіси",
  "YS_p1": "Yesan - це динамічна компанія-розробник програмного забезпечення, що спеціалізується на розробці передових мобільних додатків, адаптованих для споживачів. Завдяки глибокому розумінню мінливих потреб та вподобань сучасних технічно підкованих користувачів, Yesan прагне створювати інтуїтивно зрозумілі, цікаві та багатофункціональні мобільні додатки, які збагачують життя своїх користувачів.",
  "YS_p2": "В основі місії Yesan лежить невпинне прагнення до інновацій та творчості, кожен продукт ретельно розробляється, щоб забезпечити бездоганну функціональність та винятковий користувацький досвід.",
  "PersonalFinanceApplication": "Додаток для особистих фінансів",
  "YPF_p1": "Yesan, Personal Finance - це передовий мобільний додаток для особистих фінансів, розроблений, щоб надати користувачам комплексні інструменти для управління фінансами, які завжди під рукою. Завдяки елегантному та інтуїтивно зрозумілому інтерфейсу Yesan, Personal Finance пропонує цілісний підхід до управління фінансами, розрахований на користувачів з будь-яким рівнем фінансової грамотності.",
  "YPF_p2": "Основні функції включають відстеження бюджету, категоризацію витрат і моніторинг транзакцій у реальному часі, що дозволяє користувачам без особливих зусиль отримати уявлення про свої витратні звички. Додаток також пропонує настроювані варіанти бюджетування, що дозволяє користувачам встановлювати фінансові цілі та відстежувати їхній прогрес у часі.",
  "YPF_p3": "Крім того, Yesan, Personal Finance надає пріоритет безпеці, використовуючи найсучасніші протоколи шифрування для захисту конфіденційної фінансової інформації користувачів. Завдяки заходам безпеки на рівні банку, користувачі можуть впевнено пов'язувати свої рахунки та синхронізувати транзакції без шкоди для конфіденційності.",
  "YPF_p4": "Yesan, Personal Finance виходить за рамки базового бюджетування, пропонуючи глибоку аналітику та персоналізовані рекомендації для оптимізації фінансових рішень. Незалежно від того, чи йдеться про визначення потенційних можливостей для заощаджень, моніторинг інвестиційних портфелів або управління стратегіями погашення боргів, додаток надає індивідуальну інформацію, щоб допомогти користувачам досягти своїх фінансових цілей.",
  "Discover": "Дізнатися",
  "Firstname": "Ім'я",
  "Lastname": "Прізвище",
  "Company":"Компанія",
  "Subject": "Тема",
  "Email": "Електронна пошта",
  "Message": "Повідомлення",
  "ThankYouForContactingUs": "Дякуємо, що звернулися до нас",
  "ValidFirstnameRequired": "Потрібно ввести дійсне ім'я.",
  "ValidLastnameRequired": "Потрібно ввести дійсне прізвище.",
  "ValidEmailAddressRequired": "Будь ласка, введіть дійсну адресу електронної пошти.",
  "ValidSubjectRequired": "Будь ласка, виберіть правильну тему.",
  "ValidMessageRequired": "Будь ласка, введіть правильне повідомлення.",
  "UnableToSendTheFormPleaseRetryLater": "Не вдалося відправити форму, будь ласка, спробуйте пізніше.",
  "Information": "Інформація",
  "Sales":"Продажі",
  "Support": "Підтримка",
  "Press": "Преса",
  "Partnership": "Партнерство",
  "Other": "Інше",
  "Blog":"Блог",

  "Accept":"Прийняти",
  "Decline":"Відхилити",

  "WorklogCalendar":"Календар робочого журналу для Jira",

  "DirectlyAccessibleInProjectApps":"Безпосередній доступ у проєктних додатках",
  "VisualizeWhereYouSpentYourTime":"Візуалізуйте, де ви витратили свій час",
  "AllYourWorklogsInACalendar":"Всі ваші робочі журнали в календарі",
  "MonthSummary":"Підсумки за місяць",
  "CheckIfYouForgotToLogTime":"Перевірте, чи не забули ви записати час.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Прямий доступ до завдань і часу оновлення",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Натисніть на елемент робочого журналу, щоб отримати прямий доступ до завдань і відредагувати відстежений час",
  "AlsoAvailableInDarkMode":"Також доступний у темному режимі",
  "DirectlyLogWorkOnTheCalendarVisually":"Безпосередньо реєструйте роботу в календарі візуально",
  "ClickOnTheCalendarToCreateNewWorklog":"Натисніть на календар, щоб створити новий робочий журнал",

  "AppsForAtlassian":"Додатки для Atlassian",
  "YCL_p1":"Візуалізуйте всі свої робочі журнали в календарі з можливістю перегляду за місяцями, тижнями, робочими тижнями та днями.",
  "YCL_p2":"Реєструйте роботу безпосередньо з календаря, візуально обираючи часовий інтервал.",
  "YCL_p3":"Визначте, чи забули ви відстежувати час для своїх табелів обліку робочого часу.",
  "YCL_p4":"Доступно вашою мовою: Англійська (Великобританія), англійська (США), китайська (спрощена), китайська (традиційна), чеська, данська, голландська, естонська, фінська, французька, німецька, угорська, ісландська, італійська, японська, корейська, норвезька, польська, португальська (Бразилія), португальська (Португалія), російська, іспанська, шведська, турецька.",

  "Kakeibo":"Какейбо",
  "Genea":"Genea",
  "FinancialPortfolio":"Фінансовий портфель для Jira",
  "BringRealFinancialPortfolio":"Забезпечте реальне управління фінансовим портфелем у Jira. Відстежуйте бюджети, капітальні та операційні витрати, а також витрати на проекти в одному місці.",
  "YFPAboutQ":"Скільки насправді коштують нам наші проекти в Jira?",
  "YFPAbout":"Фінансовий портфель для Jira\nКерівники фінансових відділів та PMO намагаються відповісти на просте запитання:\nСкільки насправді коштують нам наші проекти Jira?\nJira відстежує роботу.\nФінансовий відділ відстежує бюджети.\nЦя програма нарешті поєднує ці два аспекти.\n\nФінансовий портфель перетворює Jira на легку платформу PPM + фінансового планування — без необхідності використання дорогих корпоративних інструментів.",
  "YFPPorfolioQ":"Бюджети та відстеження портфелів",
  "YFPPorfolioP":"Створюйте портфелі з декількох проектів Jira та визначайте: суму бюджету, валюту, діапазон дат, включені проекти, команди. Автоматично відстежуйте фактичні витрати у міру виконання роботи в Jira.",
  "YFPPorfolioListQ":"Портфелі",
  "YFPPorfolioListP":"Створюйте фінансові портфелі, що об'єднують кілька проектів Jira, і миттєво бачте: порівняння бюджету з фактичними витратами, швидкість витрачання коштів у реальному часі, розбивку CapEx та OpEx, вартість за завдання та проект, фінансові звіти для експорту. Все це безпосередньо на основі журналів роботи Jira.",
  "CostQ":"Автоматичний розрахунок витрат",
  "CostP":"Перетворіть відстеження часу на реальні фінансові дані. Додаток: зчитує журнали роботи Jira, застосовує погодинні ставки, щодня розраховує реальні витрати на проект. Без таблиць. Без ручної роботи.",
  "RatesQ":"Ставки",
  "RatesP":"Встановіть погодинну ставку для кожного проекту, команди або глобально",
  "ReportQ":"Фінансова звітність у форматі CSV",
  "ReportP":"Експортуйте фінансові дані портфеля за лічені секунди. Ідеально підходить для: фінансових команд, звітності фінансового директора, планування бюджету, підтримки аудиту",
  "SettingsQ":"Класифікація CapEx та OpEx",
  "SettingsP":"Підтримка вимог бухгалтерського обліку та аудиту. Класифікуйте роботу на: капіталізовану розробку (CapEx) та операційну роботу (OpEx). Створюйте звіти, готові до експорту, для фінансових команд."
};

export const documents = {
};
